module.exports = __webpack_public_path__ + "img/guajiangqu.4267e87f.png";